<template>
    <div>
        <template>
            <h4 class="not-margin"
                :style="{ fontWeight: 'bold', color: '#195BFF', fontSize: '18px', textAlign: 'left' }">
                <i class="fal fa-plus-circle" :style="{ width: '25px', fontSize: '18px' }"></i>
                ເພີ່ມ ທີ່ຢູ່ຂົນສົ່ງ ( Shipping Address )
            </h4>
        </template>

        <div class="columns is-multiline" :style="{ marginTop: '20px' }">
            <div class="column is-half">
                <div class="control">
                    <label class="label">
                        ຫົວຂໍ້ ( Title ) <span style="color: #888">- ບໍ່ບັງຄັບ</span>
                        <span class="text-danger">{{ server_errors.title }}</span>
                    </label>
                    <input
                        type="text" class="input"
                        name="title"
                        placeholder="ຕົວຢ່າງ: ຂົນສົ່ງທາງລົດ ( ເມືອງຫຼ້າ - ວຽງຈັນ )"
                        v-model="value.title"
                        maxlength="255"
                    >
                </div>
            </div>

            <div class="column is-half">
                <div class="control">
                    <label class="label">
                        ຊື່ຜູ້ຮັບ
                        <span class="text-danger">* {{ errors.first('receiver_name') }}</span>
                        <span class="text-danger">{{ server_errors.receiver_name }}</span>
                    </label>
                    <input
                        type="text" class="input"
                        name="receiver_name"
                        placeholder="HAL,(branch_code)"
                        v-model="value.receiver_name"
                        v-validate="'required|max:255'"
                        maxlength="255"
                    >
                </div>
            </div>

            <div class="column is-half">
                <div class="control">
                    <label class="label">
                        ເບີໂທ
                        <span class="text-danger">* {{ errors.first('phone') }}</span>
                        <span class="text-danger">{{ server_errors.phone }}</span>
                    </label>
                    <input
                        type="text" class="input"
                        name="phone"
                        placeholder="18088107412"
                        v-model="value.phone"
                        v-validate="'required|max:32'"
                        maxlength="32"
                    >
                </div>
            </div>

            <div class="column is-half">
                <div class="control">
                    <label class="label">
                        ລະຫັດໄປສະນີ <span style="color: #888">- ບໍ່ບັງຄັບ</span>
                        <span class="text-danger">{{ server_errors.postal_code }}</span>
                    </label>
                    <input
                        type="text" class="input"
                        name="postal_code"
                        placeholder="..."
                        v-model="value.postal_code"
                        maxlength="16"
                    >
                </div>
            </div>

            <div class="column is-half">
                <div class="control">
                    <label class="label">
                        ປະເພດການຂົນສົ່ງ
                        <span class="text-danger">* {{ errors.first('transport_type') }}</span>
                        <span class="text-danger">{{ server_errors.transport_type }}</span>
                    </label>
                    <div class="select">
                        <select
                            class="input"
                            name="transport_type"
                            v-model="value.transport_type"
                            v-validate="'required'"
                        >
                            <option v-for="(t, i) in transportTypes" :key="i" :value="t.id">{{ t.name }}</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="column is-half">
                <div class="control">
                    <label class="label">
                        ປະເທດປາຍທາງ
                        <span class="text-danger">* {{ errors.first('address_country') }}</span>
                        <span class="text-danger">{{ server_errors.address_country }}</span>
                    </label>
                    <div class="select">
                        <select
                            class="input"
                            name="address_country"
                            v-model="value.address_country"
                            v-validate="'required'"
                        >
                            <option v-for="(c, i) in addressCountries" :key="i" :value="c.id">{{ c.name }}</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="column is-half">
                <div class="control">
                    <label class="label">
                        ເຂດ/ເມືອງ ( District )
                        <span class="text-danger">* {{ errors.first('address_district') }}</span>
                        <span class="text-danger">{{ server_errors.address_district }}</span>
                    </label>
                    <input
                        type="text" class="input"
                        name="address_district"
                        placeholder="ຕົວຢ່າງ: 勐腊县"
                        v-model="value.address_district"
                        v-validate="'required|max:255'"
                        maxlength="255"
                    >
                </div>
            </div>

            <div class="column is-full">
                <div class="control">
                    <label class="label">
                        ທີ່ຢູ່ເຕັມ ( Full Address )
                        <span class="text-danger">* {{ errors.first('address') }}</span>
                        <span class="text-danger">{{ server_errors.address }}</span>
                    </label>
                    <textarea
                        class="input"
                        rows="3"
                        name="address"
                        placeholder="ຕົວຢ່າງ: 云南省西双版纳傣族自治州勐腊县勐腊镇HAL国际仓转HAL(branch_code)/(name)/(phone)"
                        v-model="value.address"
                        v-validate="'required'"
                    />
                    <p style="font-size: 12px; color: #888; margin-top: 4px">
                        * Placeholder ເຊັ່ນ <code>(branch_code)</code>, <code>(name)</code>, <code>(phone)</code> ຈະຖືກປ່ຽນຄ່າຢູ່ Server.
                    </p>
                </div>
            </div>
        </div>

        <button
            class="button"
            :class="{ 'is-loading': btnLoading }"
            :style="{ marginTop: '20px', width: '30%' }"
            @click="ValidateForm()"
        >
            ບັນທຶກ
        </button>
    </div>
</template>

<script>
import mixinsAddShippingAddress from '@coms/../../src/Mixins/Shipping-Addresses/Add';
import { ValidateShipping } from '@coms/../../src/Plugins/Validation/Validate-Shipping';

export default {
    mixins: [mixinsAddShippingAddress],
    created() {
        ValidateShipping(this);
    },
};
</script>

<style lang="scss" scoped>
.button {
    &:hover {
        color: $white;
    }
}
</style>
